import React from 'react';
import List from './List';
import Detail from './Detail';
// import SearchInput from './SearchInput';
import Filters from './Filters';
import s from './FilteredList.css';
import dataJson from '../../../jsonCMS/processed/catalog-2016.en.json';

/** @type {Object} Configuration  (TODO: make in central) */
const config = {
  facets: {
    fields: ['gender', 'season', 'line', 'type', 'purpose', 'colors'],
  },
};

/**
 * Filtered list class
 */
class FilteredList extends React.Component {

  /** Class initialization */
  constructor(props) {
    super(props);
    console.log(props);

    this.facets = {}; // initial value
    this.facetFields = config.facets.fields;
    this.defaultFilters = this.facetFields.reduce(
      (filters, name) => ({ ...filters, [name]: '_all' })
    , {});

    this.defaultState = {
      // items: [],
      filters: this.defaultFilters,
      searchText: '',
      selected: '',
    };

    /** @type {Object} Initial state */
    this.state = { ...this.defaultState };
  }

  componentWillMount() {
    // TODO: out of here - run after data ajax'ed GET
    this.facets = this.buildFacets(this.getAllItems());
  }

  /**
   * Handler: search
   * @param  {String} text Query string
   */
  onSearch = text => {
    this.setState({ ...this.state, searchText: text, selected: '' });
  }

  /**
   * Handler: filter
   * @param  {Object} filters Multiple filters to match
   */
  onFilter = filters => {
    this.setState({ ...this.state, filters, selected: '' });
  }

  /**
   * Handler: select item
   * @param  {*} id Selected item id
   */
  onSelectItem = (id) => {
    // let idx = this.state.items.findIndex(function(item){
    //   if (item.id === id) return true;
    // });
    // this.setState({ ...this.state, selected: idx });
    const selected = (id && typeof id === 'string') ? id : ''; // TODO: hack....
    this.setState({ ...this.state, selected });
  }

  /**
   * Reset to default state
   */
  onResetState = () => {
    this.setState(this.defaultState);
  }

  // TODO:   temp helper, until AJAX is here..
  getAllItems() {
    return Object.keys(dataJson).map(k => dataJson[k]);
  }

  /**
   * Facets processor: re-calculate facets counters
   * @param  {Array} items           Items list
   * @param  {Object} originalFacets Original facets to process
   * @return {Object}                Processed facets
   */
  getUpdatedFacets(items, originalFacets) {
    return Object.keys(originalFacets).reduce((facets, name) => {
      const values = Object.keys(facets[name]).reduce((facet, field) => {
        // Count the number of matches in the items array
        const count = items.reduce((cnt, item) => {
          const fieldValue = item[name];
          const match = (fieldValue === field) ||
                        (Array.isArray(fieldValue) && fieldValue.indexOf(field) > -1);
          return (match) ? cnt + 1 : cnt;
        }, 0);

        return { ...facet, [field]: count };
      }, facets[name]);

      return { ...facets, [name]: values };
    }, originalFacets);
  }

  /**
   * Generate the facets object from an items list
   * @param  {Array} items Items list
   * @return {Object}      Facets
   */
  buildFacets(items) {
    return this.facetFields.reduce((facets, field) => {
      const values = items.reduce((col, item) => {
        const collection = col;
        const fieldValue = item[field];
        if (!fieldValue) return collection;

        // DEPRECATED: we don't the count anymore,  we do this now on getUpdatedFacets
        if (Array.isArray(fieldValue)) {
          fieldValue.forEach((v) => { collection[v] = (collection[v]) ? col[v] + 1 : 1; });
        } else {
          collection[fieldValue] = (collection[fieldValue]) ? col[fieldValue] + 1 : 1;
        }
        return collection;
      }, {});

      return { ...facets, [field]: values };
    }, {});
  }

  /**
   * Filter items array by filters and/or search text
   * @param  {Array} items          Items list
   * @param  {Object} filters       Multiple filters to match
   * @param  {String} (searchText)  Query text
   * @return {Array}                Filtered list of matching items
   */
  filterItems(items, filters, searchText) {
    return items.filter(item => {
      // Content text search    //TODO: replace with SOLR (or alike)
      if ((searchText !== '') &&
          (item.description.toLowerCase().indexOf(searchText.toLowerCase()) === -1)) {
        return false;
      }

      // Facets filters
      return ! Object.keys(filters).some(f => {
        if (filters[f] === '_all') { return false; }  // TODO: "_all" is a hack..
        const values = (Array.isArray(item[f])) ? item[f] : [item[f]]; // wrap into array
        return ! values.some(v => (v === filters[f]));
      });
    });
  }

  /**
   * React renderer
   */
  render() {
    const { filters, searchText, selected } = this.state;
    const filteredItems = this.filterItems(this.getAllItems(), filters, searchText);
    const facets = this.getUpdatedFacets(filteredItems, this.facets);

    return (
      <div className={s.container}>

        <div className={s.filters} style={{flex: (selected) ? 0 : 2}}>
        {/*
          <SearchInput
            searchText={searchText}
            onSearch={this.onSearch}
          />
        */}
          <Filters
            filters={filters}
            onFilter={this.onFilter}
            onFilterReset={this.onResetState}
            facets={facets}
          />
        </div>

        <div className={s.listWrapper}>
          <div className={s.list}>
            <input type="button" onClick={this.onSelectItem} value="Back" style={{display: (selected) ? 'block' : 'none'}} />
            <List
              items={filteredItems}
              selected={selected}
              selectItem={this.onSelectItem}
            />
          </div>

          <div className={s.detail} style={{ minWidth: (selected) ? '20em' : 0 }}>
            <Detail item={(selected) ? dataJson[selected] : {}} />
          </div>
        </div>
      </div>
    );
  }
}

export default FilteredList;



/** WEBPACK FOOTER **
 ** ./components/Products/FilteredList.js
 **/